import { inject, Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { environment } from '../../../../environments/environment';
import { LoggerFactory } from '../logger/logger-factory.service';
import { LoggerWrapper } from '../logger/logger-wrapper.service';
import { HttpClient } from '@angular/common/http';
import { FirebasePerformance } from '@capacitor-firebase/performance';
import { Capacitor } from '@capacitor/core';
import { DactechDeviceInfo } from '../device/device.model';

export enum ButtonClicked {
  SITE_PAGE_SITE_INFOS = 'siteInfos',
  SITE_PAGE_AFFICHER_LES_OTS = 'afficher les OTs',
  SITE_PAGE_BOUTONPLUS = 'boutonPlus',
  SITE_PAGE_ALLERAUXDOCUMENTS = 'allerAuxDocuments',
  SITE_PAGE_ACCEDERPATRIMOINE = 'accederPatrimoine',
  SITE_PAGE_YALLER = 'yAller',
  SITE_PAGE_GOTOSUIVIENERGETIQUE = 'goToSuiviEnergetique',
  SITE_PAGE_ANNULERBOUTONPLUS = 'annulerBoutonPlus',
  SITE_PAGE_OUVRIROTNONPLANIFIE = 'ouvrirOtNonPlanifie',
  SITE_PAGE_SAISIRCROTNONPLANIFIE = 'saisirCrOtNonPlanifie',

  AGENDA_PAGE_ZOOM_PLUS = 'agenda_zoomplus',
  AGENDA_PAGE_ZOOM_MOINS = 'agenda_zoommoins',
}

@Injectable({
  providedIn: 'root',
})
export class AnalyticsProvider {
  available = false;
  apiDactechUrl: string;
  private loggerFactory = inject(LoggerFactory);
  /**
   * Logger
   */
  private logger: LoggerWrapper;

  /**
   * Constructeur
   *
   * Crée une instance de FabricProvider.
   *
   * @param {Platform} platform
   * @param http
   */
  constructor(
    private platform: Platform,
    private http: HttpClient
  ) {
    this.apiDactechUrl = environment.apis.API_DACTECH_BACK_ROOT;
    this.logger = this.loggerFactory.getInstance(this);
    this.platform.ready().then(() => {
      this.available = this.platform.is('mobileweb') ? false : true;
    });
  }

  async sendDeviceInfo(device_infos: DactechDeviceInfo) {
    this.http.post(this.apiDactechUrl + '/v1/analytics/utilisation_dactech', device_infos).subscribe();
  }

  sendLogIn(login: string, success: boolean, userData: any) {
    // TODO: to implement
    console.log('TODO: to implement');
  }

  sendContentView(page: any, type: any, id: any, data: any) {
    // TODO: to implement
    console.log('TODO: to implement');
  }

  sendCustom(custom_name: string, data: Object = {}) {
    // TODO: to implement
    console.log('TODO: to implement');
  }

  trackClick(buttonName: ButtonClicked, data = {}) {
    // TODO: to implement
    console.log('TODO: to implement');
  }

  /**
   * Mesure le temps pris par la promesse et l'exécute (seulement en mode application mobile)
   * @param eventName nom de l'événement à tracer sur firebase
   * @param promise promesse à exécuter
   * @returns {any} renvoie le résultat de la promesse
   */
  async mesureTimePromise(eventName: string, promise) {
    // console.log("mesureTimePromise", eventName, this.available);
    if (this.available) {
      await this.setPerformanceCollectionEnabled(true);
      if (Capacitor.isNativePlatform()) {
        const startTrace = async () => {
          await FirebasePerformance.startTrace({ traceName: eventName });
        };
        console.log(startTrace);
      } else {
        await window['FirebasePerformance']?.startTrace(eventName);
      }
    }
    try {
      let result = await promise();
      return result;
    } finally {
      if (this.available) {
        if (Capacitor.isNativePlatform()) {
          const startTrace = async () => {
            await FirebasePerformance.stopTrace({ traceName: eventName });
          };
          console.log(startTrace);
        } else {
          await window['FirebasePerformance']?.stopTrace(eventName);
        }
      }
    }
  }

  recordError(error: any) {
    // TODO: to implement
    console.log('TODO: to implement');
  }

  setPerformanceCollectionEnabled(enabled: boolean): Promise<any> {
    // TODO: to implement
    console.log('TODO: to implement');
    return null;
  }

  setUserProperties(key: string, value: string) {
    // TODO: to implement
    console.log('TODO: to implement');
  }
}
